import { create } from 'zustand'

// Modo "Visualização" (só-leitura) — toggle de sessão DO ADMIN.
// Quando ligado, o interceptor do axios bloqueia toda escrita (POST/PUT/PATCH/DELETE)
// em todo o sistema. É preferência por navegador (localStorage), reversível.
const KEY = 'velore_readonly'
const ADMIN = ['admin', 'super_admin']

function usuarioAtual(): any {
  try { return JSON.parse(localStorage.getItem('pain_user') || '{}') } catch { return {} }
}
function perfilAtual(): string { return usuarioAtual()?.perfil || '' }
export function isAdmin(): boolean { return ADMIN.includes(perfilAtual()) }

// Impersonação: admin "entrou" como um usuário (Configurações → Usuários).
// pain_imp = { nome, modo: 'visualizacao'|'edicao' }; pain_impersonator = backup do admin.
export function impAtual(): { nome: string; modo: string } | null {
  try { return JSON.parse(localStorage.getItem('pain_imp') || 'null') } catch { return null }
}
export function isImpersonando(): boolean { return !!localStorage.getItem('pain_impersonator') }

interface ReadonlyState {
  readonly: boolean
  setReadonly: (b: boolean) => void
  toggle: () => void
}
export const useReadonly = create<ReadonlyState>((set, get) => ({
  readonly: localStorage.getItem(KEY) === 'true',
  setReadonly: (b) => { localStorage.setItem(KEY, b ? 'true' : 'false'); set({ readonly: b }) },
  toggle: () => get().setReadonly(!get().readonly),
}))

// Consulta fora do React (usada pelo interceptor do axios).
// Bloqueia escrita quando: (a) impersonando em modo 'visualizacao', OU
// (b) o admin ligou o toggle de sessão "Visualização".
export function isReadonlyActive(): boolean {
  // Só bloqueia por impersonação se a sessão de impersonação está REALMENTE ativa
  // (tem o backup do admin + a faixa "voltar"). Um pain_imp órfão não trava.
  const imp = impAtual()
  if (imp && imp.modo === 'visualizacao' && isImpersonando()) return true
  return localStorage.getItem(KEY) === 'true' && isAdmin()
}
